import { Component } from '@angular/core';
import {
  ModalController,
  IonHeader,
  IonToolbar,
  IonButton,
  IonButtons,
  IonTitle,
  IonContent,
  IonItem,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonText,
  IonIcon,
  IonFabButton,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonLabel,
} from '@ionic/angular/standalone';
import { CategoryService } from '../../services/category.service';
import { Category } from '../../models/category.model';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { arrowUpOutline, closeCircleOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';

export interface CreateItemForm {
  name: FormControl<string | null>,
  price: FormControl<number | null>,
  categoryId: FormControl<string | null>,
  images: FormControl<File[] | null>,
  description: FormControl<string | null>,
}

@Component({
  selector: 'app-create-product-modal',
  templateUrl: './create-product-modal.component.html',
  styleUrls: ['./create-product-modal.component.scss'],
  standalone: true,
  imports: [
    IonLabel,
    IonHeader,
    IonToolbar,
    IonButton,
    IonButtons,
    IonTitle,
    IonContent,
    IonItem,
    IonInput,
    IonSelect,
    IonSelectOption,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    IonText,
    IonIcon,
    IonFabButton,
    IonGrid,
    IonRow,
    IonCol,
    IonCard,
  ],
})
export class CreateProductModalComponent {
  categories: Category[] = [];
  images: File[] = [];
  imgUrls: any[] = [];

  createItemForm: FormGroup<CreateItemForm> = new FormGroup({
    name: new FormControl('', [Validators.required]),
    price: new FormControl(0.0, [Validators.required]),
    categoryId: new FormControl('', [Validators.required]),
    images: new FormControl(this.images, [Validators.required]),
    description: new FormControl('', [Validators.required]),
  });

  constructor(
    private modalController: ModalController,
    private categoryService: CategoryService,
  ) {
    addIcons({ arrowUpOutline, closeCircleOutline });
  }

  ionViewWillEnter(): void {
    this.categoryService
      .getCategories()
      .subscribe((response: Category[]) => (this.categories = response));
  }

  cancel() {
    return this.modalController.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalController.dismiss(this.createItemForm, 'confirm');
  }

  canDismiss() {
    if (
      this.createItemForm.get('price')?.hasError('required') ||
      this.createItemForm.get('name')?.hasError('required') ||
      this.createItemForm.get('category')?.hasError('required') ||
      this.createItemForm.get('description')?.hasError('required')
    ) {
      this.createItemForm.get('price')?.markAsTouched();
      this.createItemForm.get('name')?.markAsTouched();
      this.createItemForm.get('categoryId')?.markAsTouched();
      this.createItemForm.get('description')?.markAsTouched();
    } else {
      this.confirm();
    }
  }

  onFileSelected(event: any) {
    // Get the new Files
    const newFiles: FileList = event.target.files;
    this.images = Array.from(newFiles);

    // Update the previews.
    if (this.images && this.images[0]) {
      const numberOfFiles = this.images.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.imgUrls.push(e.target.result);
        };

        reader.readAsDataURL(this.images[i]);
      }
    }

    // Set the Form Control, with the old & new images
    const formFiles: File[] | null = this.createItemForm.controls.images.value
    const fileArray: File[] = this.images.concat(formFiles ?? []);

    this.createItemForm.controls.images.setValue(fileArray);
  }

  deleteImg(image: any) {
    this.imgUrls = this.imgUrls.filter((img) => img != image);
  }
}
